
export const tableRows = (rows) => {
    const groupedRows = rows.reduce((acc, row) => {
      // Find the index of the asset group in the accumulator array
      const index = acc.findIndex((group) => group.AssetGroupID === row.AssetGroupID);
    
      // If the asset group doesn't exist in the accumulator array yet, add it
      if (index === -1) {
        acc.push({
          AssetGroupType: row.AssetGroupType,
          AssetGroupID: row.AssetGroupID,
          AssetTypes: [
            {
              AssetTypeID: row.AssetTypeID,
              AssetName: row.AssetName,
              Suffixes: [
                {
                  SuffixID: row.SuffixID,
                  SuffixName: row.SuffixName || 'N/A'
                }
              ]
            }
          ]
        });
      } else { // Otherwise, add the asset type and suffix to the existing group
        const suffix = {
          SuffixID: row.SuffixID,
          SuffixName: row.SuffixName || 'N/A'
        };
        const assetType = {
          AssetTypeID: row.AssetTypeID,
          AssetName: row.AssetName,
          Suffixes: [suffix]
        };
        const assetTypes = acc[index].AssetTypes;
        const assetTypeIndex = assetTypes.findIndex((type) => type.AssetTypeID === row.AssetTypeID);
    
        if (assetTypeIndex === -1) {
          assetTypes.push(assetType);
        } else {
          assetTypes[assetTypeIndex].Suffixes.push(suffix);
        }
      }
    
      return acc;
    }, []);
    return groupedRows
  }